// import { inject } from '@angular/core';
// import { CanActivateFn, Router } from '@angular/router';
// import { AuthService } from '../../../features/auth/auth.service';

// /**
//  * Route-level guard.
//  * Usage in routes:  canActivate: [pageGuard]
//  * The route must have data: { pageName: 'My Purchases' }
//  * matching the `name` field returned by the login API's pages array.
//  */
// export const pageGuard: CanActivateFn = (route, state) => {
//   const authService = inject(AuthService);
//   const router = inject(Router);

//   // Not logged in at all → send to login
//   if (!authService.isLoggedIn()) {
//     router.navigate(['/login']);
//     return false;
//   }

//   // No pageName restriction on this route → allow any authenticated user
//   const pageName: string | undefined = route.data?.['pageName'];
//   if (!pageName) {
//     return true;
//   }

//   // Check if the user's pages list includes this pageName
//   if (authService.hasAccess(pageName)) {
//     return true;
//   }

//   // Logged in but no permission → redirect to their role's home
//   const role = authService.getUserRole();
//   if (role === 'vendor') {
//     router.navigate(['/vendor/home']);
//   } else if (role === 'admin') {
//     router.navigate(['/admin/dashboard']);
//   } else {
//     router.navigate(['/customer']);
//   }

//   return false;
// };

import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../../../features/auth/auth.service';

export const pageGuard: CanActivateFn = (route) => {
  const auth = inject(AuthService);
  const router = inject(Router);

  if (!auth.isLoggedIn()) {
    router.navigate(['/login']);
    return false;
  }

  const userRole = auth.getUserRole();

  // role check first
  const allowedRole = route.data?.['role'];

  if (allowedRole && allowedRole !== userRole) {
    redirectByRole(userRole, router);
    return false;
  }

  // page check second
  const pageName = route.data?.['pageName'];

  if (pageName && !auth.hasAccess(pageName)) {
    redirectByRole(userRole, router);
    return false;
  }

  return true;
};

function redirectByRole(role: string, router: Router) {
  switch (role) {
    case 'admin':
      router.navigate(['/admin/dashboard']);
      break;

    case 'vendor':
      router.navigate(['/vendor/home']);
      break;

    default:
      router.navigate(['/customer/dashboard']);
  }
}